import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const servicesData = [
  { id: 1, title: "Private Limited/OPC Registration", desc: "A Private Limited Company is the most versatile legal structure for businesses in India, offering limited liability protection and a separate legal identity. One Person Company (OPC) allows a single entrepreneur to operate a corporate entity. Our comprehensive registration service includes obtaining Digital Signature Certificates (DSC), Director Identification Numbers (DIN), name approval from the Ministry of Corporate Affairs (MCA), and drafting the Memorandum and Articles of Association (MOA/AOA)." },
  { id: 2, title: "LLP/Partnership Firm Registration", desc: "Limited Liability Partnership (LLP) provides the benefits of limited liability while allowing the flexibility of an internal partnership structure. For smaller businesses, a traditional Partnership Firm is a viable option. We handle the entire documentation process, including the drafting of the Partnership or LLP Deed, filing with the Registrar of Companies (ROC) or Registrar of Firms, and obtaining the entity's PAN and TAN." },
  { id: 3, title: "Sole Proprietorship Firm Registration", desc: "Sole Proprietorship is an ideal structure for individual micro-entrepreneurs. It is easy to start and has minimal regulatory requirements. We assist in establishing your business identity by obtaining necessary government registrations such as the Shop and Establishment Act (Gumasta) license, MSME Udyam certification, and other local permits required to open a current bank account and commence business operations." },
  { id: 4, title: "Trademark Registration", desc: "Protecting your unique brand name, logo, or slogan is crucial in today's competitive market. Our Trademark Registration service includes a comprehensive search to ensure brand availability, filing the application under the correct classes, and managing the process through to registration. We provide legal support in case of trademark objections or oppositions to safeguard your intellectual property rights." },
  { id: 5, title: "GST Registration & GST Return", desc: "GST is a mandatory tax registration for businesses exceeding specific turnover limits. We provide seamless GST registration and ensure ongoing compliance through timely filing of monthly, quarterly, and annual returns (GSTR-1, GSTR-3B). Our experts help you navigate complex GST regulations, reconcile Input Tax Credits (ITC), and ensure that your business remains in good standing with the tax authorities." },
  { id: 6, title: "FSSAI Registration", desc: "Any business involved in the manufacturing, processing, storage, distribution, or sale of food products must obtain an FSSAI license or registration. This ensures the safety and quality of food items provided to consumers. We help you identify the appropriate category (Basic, State, or Central License) based on your turnover and business scale, handling all the documentation and portal filings for a hassle-free approval." },
  { id: 7, title: "Import Export Code", desc: "The Import Export Code (IEC) is a primary requirement for any business looking to import or export goods or services from India. Issued by the DGFT, this code has lifetime validity and requires no renewal. We facilitate the quick issuance of your IEC, enabling your business to expand globally and engage in international trade transactions through official banking channels." },
  { id: 8, title: "SSI – MSME Registration", desc: "Registration under the MSME (Micro, Small, and Medium Enterprises) Act via the Udyam portal unlocks various government benefits. These include priority sector lending from banks, lower interest rates, exemptions under direct tax laws, and protection against delayed payments. We assist in accurate classification and registration to ensure your business leverages all available government subsidies and schemes." },
  { id: 9, title: "GEM Registration", desc: "The Government e-Marketplace (GeM) is a dedicated platform for different government departments and organizations to procure essential goods and services. Registering on GeM opens up massive opportunities for businesses to sell directly to government buyers. We manage the vendor assessment process, profile creation, and product/service listing on the GeM portal to help you secure government contracts." },
  { id: 10, title: "Digital Signature Certificate (DSC)", desc: "A Digital Signature Certificate (DSC) is a secure digital instrument used to sign electronic documents for various statutory filings, including MCA, Income Tax, GST, and E-Tendering. We provide Class 3 DSCs with high-level security for individuals and organizations. Our service includes identity verification and issuance of the certificate on secure USB tokens, ensuring you can perform online transactions with complete authenticity." }
];

export default function Services() {
  const location = useLocation();
  const [activeId, setActiveId] = useState(1);

  useEffect(() => {
    if (location.state && location.state.activeServiceId) {
      setActiveId(Number(location.state.activeServiceId));
    }
    window.scrollTo(0, 0);
  }, [location.state]);

  const selectedService = servicesData.find((s) => s.id === activeId);

  return (
    <div
      className="px-4 py-10 sm:px-6 sm:py-12"
      style={{ padding: "80px 20px", backgroundColor: "#f4f7fa", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}
    >
      
      {/* HEADING SECTION */}
      <div className="mb-10 sm:mb-14" style={{ textAlign: "center", marginBottom: "60px" }}>
        <h2
          className="text-2xl sm:text-3xl"
          style={{ fontSize: "32px", fontWeight: "900", color: "#0f2b46", textTransform: "uppercase", letterSpacing: "1px", margin: "0" }}
        >
          Our Professional Services
        </h2>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
          <div style={{ width: "80px", height: "3px", backgroundColor: "#22c55e" }}></div>
          <div style={{ width: "100px", height: "14px", backgroundColor: "#0f2b46", margin: "0 10px" }}></div>
          <div style={{ width: "80px", height: "3px", backgroundColor: "#22c55e" }}></div>
        </div>
      </div>
      
      {/* MAIN FLEX CONTAINER */}
      <div
        className="flex flex-col lg:flex-row"
        style={{ 
          display: "flex", 
          gap: "30px", 
          maxWidth: "1300px", 
          margin: "0 auto", 
          alignItems: "stretch"
        }}
      >
        
        {/* SIDEBAR */}
        <div
          className="w-full lg:w-auto"
          style={{ flex: "0 0 400px", display: "flex", flexDirection: "column", gap: "10px" }}
        >
          {servicesData.map((service) => (
            <div
              key={service.id}
              onClick={() => setActiveId(service.id)}
              className="p-4 sm:p-5 text-sm sm:text-base"
              style={{ 
                padding: "18px 25px", 
                cursor: "pointer", 
                borderRadius: "10px", 
                backgroundColor: activeId === service.id ? "#0f2b46" : "#fff",
                color: activeId === service.id ? "#fff" : "#444",
                boxShadow: "0 4px 10px rgba(0,0,0,0.03)",
                transition: "0.3s all ease",
                fontWeight: "700",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid rgba(0,0,0,0.05)",
                fontSize: "16px"
              }}
            >
              {service.title}
              <span style={{ fontSize: "20px", opacity: activeId === service.id ? 1 : 0.3 }}>
                {activeId === service.id ? "●" : "›"}
              </span>
            </div>
          ))}
        </div>

        {/* CONTENT */}
        <div
          className="w-full"
          style={{ 
            flex: "1", 
            backgroundColor: "#fff", 
            padding: "50px 60px", 
            borderRadius: "15px", 
            boxShadow: "0 15px 40px rgba(0,0,0,0.06)", 
            border: "1px solid #eef2f6",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={activeId}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >
              <h3
                className="text-xl sm:text-2xl lg:text-3xl"
                style={{ color: "#0f2b46", fontSize: "32px", marginBottom: "15px", fontWeight: "850", letterSpacing: "-0.5px" }}
              >
                {selectedService?.title}
              </h3>
              
              <div style={{ width: "60px", height: "5px", backgroundColor: "#22c55e", borderRadius: "10px", marginBottom: "35px" }}></div>
              
              <p
                className="text-sm sm:text-base lg:text-lg leading-relaxed"
                style={{ 
                  color: "#475569", 
                  lineHeight: "1.9", 
                  fontSize: "18.5px", 
                  textAlign: "justify", 
                  margin: 0,
                  fontWeight: "400"
                }}
              >
                {selectedService?.desc}
              </p>
              
              <div
                className="hidden sm:block"
                style={{ 
                  position: "absolute", 
                  bottom: "-20px", 
                  right: "-20px", 
                  fontSize: "150px", 
                  color: "#f8fafc", 
                  zIndex: 0, 
                  fontWeight: "900",
                  userSelect: "none"
                }}
              >
                {activeId}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

      </div>
    </div>
  );
}